/* unplugin-vue-components disabled */import { render } from "./CaptchaPlus.vue?vue&type=template&id=6fae986c&scoped=true"
import script from "./CaptchaPlus.vue?vue&type=script&lang=js"
export * from "./CaptchaPlus.vue?vue&type=script&lang=js"

import "./CaptchaPlus.vue?vue&type=style&index=0&id=6fae986c&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@5.8.3__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fae986c"]])

export default __exports__